import LabServiceModel from "@/models/LabServiceModel";
import ProjectModel from "@/models/lab/ProjectModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import TurnaroundModel from "@/models/lab/TurnaroundModel";
import SampleCollection from "@/collections/lab/SampleCollection";
import TestPackageModel from "./TestPackageModel";
import SubmissionStatusLogCollection from "@/collections/lab/SubmissionStatusLogCollection";

export default class SubmissionModel extends LabServiceModel {
  modelName() {
    return 'submission';
  }
  icon() {
    return 'shovel';
  }
  methods() {
    const methods = super.methods();

    methods.releaseSubmission = "POST";

    methods.submissionReport = "GET";
    
    return methods;
  }
  routes() {
    const routes = super.routes();

    routes.releaseSubmission = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}/{id}/release`;
    routes.submissionReport = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}/{id}/report`;

    return routes;
  }
  defaults() {
    return {
      id: null,
      pid: null,
      project_id: null,
      project: null,
      sample_type_id: null,
      sample_type: null,
      test_package_id: null,
      test_package: null,
      turnaround_id: null,
      turnaround: null,
      identifier: null,
      event_code: null,
      note: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      samples: {},
      submission_soil: null,
      submission_tissue: null,
      submission_feed_mixer_efficiency: null,
      submission_feeds: null,
      submission_irrigation_suitability: null,
      submission_septic_soil: null,
      submission_potato: null,
      submission_water: null,
      submission_waste_water: null,
      submission_status_logs: [],

      // additional fields that can be injected based on the submission type
      attribute_1: null,
      attribute_2: null,
      attribute_3: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      pid: (val) => (this.nullStringMutator(val)),
      project_id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      turnaround_id: (val) => (this.nullStringMutator(val)),
      identifier: (val) => (this.nullStringMutator(val)),
      event_code: (val) => (this.nullStringMutator(val)),
      note: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getProject() {
    return this.getRelatedModel(ProjectModel, 'project');
  }
  getTestPackage() {
    return this.getRelatedModel(TestPackageModel, 'test_package');
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
  getTurnaround() {
    return this.getRelatedModel(TurnaroundModel, 'turnaround');
  }
  getSamples() {
    return this.getRelatedCollection(new SampleCollection(), 'samples');
  }
  getSubmissionStatusLogs() {
    return this.getRelatedCollection(new SubmissionStatusLogCollection(), 'submission_status_logs');
  }
  publicNumber() {
    return String(this.get('pid')).padStart(6, '0')
  }
  releaseSubmission(connection, params) {
    const method = this.getOption('methods.releaseSubmission');
    const route = this.getRoute('releaseSubmission');
    const url = this.getURL(route, { id: this.get('id') });
    
    return this.createRequest({ method, url, params }).send().then(response => {
      this.emit('releaseSubmission', {});

      return response;
    });
  }
  submissionReport() {
    const method = this.getOption('methods.submissionReport');
    const route = this.getRoute('submissionReport');
    const url = this.getURL(route, { id: this.get('id') });

    return this.createRequest({ method, url }).send().then(response => {
      this.emit('submissionReport', {});

      return response;
    });
  }

}
